export default __webpack_public_path__ + "static/media/BEF_FINAL_23March.9e8a2034.png";